import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function recoveryPassword (email) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getLogin)
      }, 500)
    })
  } else {
    const req = {
      url: '/api/login/passwordRecovery',
      method: 'POST',
      data: {
        email: email
      }
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { recoveryPassword }
